import { render, staticRenderFns } from "./AddGoodsType.vue?vue&type=template&id=a2766a5a&"
import script from "./AddGoodsType.vue?vue&type=script&lang=js&"
export * from "./AddGoodsType.vue?vue&type=script&lang=js&"
import style0 from "./AddGoodsType.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports